import CardContent, { type CardContentProps } from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';

const CarTileContent = styled(CardContent)<CardContentProps>(({ theme }) => ({
  color: theme.palette.text.primary,
  position: 'relative',
  cursor: 'pointer',
  height: '100%',

  '.kmx-car-tile--unavailable &': {
    color: theme.palette.text.disabled,
  },

  '.kmx-car-tile-skeleton &': {
    cursor: 'auto',
  },
}));

export default CarTileContent;
